"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunaTradeStation = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const MoonSpaces_1 = require("../../moon/MoonSpaces");
const TileType_1 = require("../../TileType");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
const MoonCard_1 = require("./MoonCard");
const Resources_1 = require("../../Resources");
const Size_1 = require("../render/Size");
class LunaTradeStation extends MoonCard_1.MoonCard {
    constructor() {
        super({
            name: CardName_1.CardName.LUNA_TRADE_STATION,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.MOON, Tags_1.Tags.SPACE],
            cost: 10,
            reserveUnits: Units_1.Units.of({ titanium: 2 }),
            metadata: {
                description: 'Spend 2 titanium. Place this tile ON THE RESERVED AREA.',
                cardNumber: 'M13',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Gain 2 M€ for each colony tile on the Moon.', (eb) => eb.empty().startAction.megacredits(2).nbsp(Size_1.Size.SMALL).slash().nbsp().moonColony().any);
                    b.br.minus().titanium(2).tile(TileType_1.TileType.LUNA_TRADE_STATION, true).asterix();
                }),
            },
        });
    }
    ;
    play(player) {
        super.play(player);
        MoonExpansion_1.MoonExpansion.addTile(player, MoonSpaces_1.MoonSpaces.LUNA_TRADE_STATION, {
            tileType: TileType_1.TileType.LUNA_TRADE_STATION,
            card: this.name,
        });
        return undefined;
    }
    surfaceColonyCount(game) {
        return MoonExpansion_1.MoonExpansion.tiles(game, TileType_1.TileType.MOON_COLONY, { surfaceOnly: true }).length;
    }
    canAct(player) {
        return this.surfaceColonyCount(player.game) > 0;
    }
    action(player) {
        const surfaceColonies = this.surfaceColonyCount(player.game);
        player.addResource(Resources_1.Resources.MEGACREDITS, 2 * surfaceColonies, { log: true });
        return undefined;
    }
}
exports.LunaTradeStation = LunaTradeStation;
//# sourceMappingURL=LunaTradeStation.js.map